import React, { useRef } from "react";
import { Formik, Field, Form } from "formik";
import { FileField } from "seed/helpers"
import l from "components/util/l";
import { uploadFile } from "components/util/file_util";
import DynamicTextArea from "components/util/helpers/DynamicTextArea";
import SchemaForm from 'components/util/schema_form/SchemaForm';
import ExcelField from "components/util/helpers/ExcelField";
import { Wizard } from "components/util/helpers/Wizard";

const ChatInput = ({
  subFormRef,
  flow,
  chat,
  botMessage,
  isLoading,
  isCancelable,
  isExecutionChat,
  isPreview,
  onSendMessage,
  onClickCancelChatAction,
}) => {

  const inputRef = useRef(null);

  const onClickAttachFiles = (setFieldValue) => {
    uploadFile({
      multiple: true,
      callback: (files) => {
        if (files.length > 0)
          setFieldValue("attachments", files);
      }
    });
  }

  const handleEnterShift = (e, submitForm, inputType) => {
    if (!inputRef.current?.contains(e.target)) return;
    if (e.keyCode == 13 && !e.shiftKey && inputType != "TEXT_AREA") {
      e.preventDefault()
      submitForm()
    }
  }

  return <div class="input-container">
    <Formik
      initialValues={{}}
      onSubmit={onSendMessage}>
      {({ values, setFieldValue, submitForm }) =>
        <Form 
          ref={inputRef}
          onKeyDown={(e) => handleEnterShift(e, submitForm, botMessage?.settings?.schema?.type ?? "TEXT")}
        >

          {
            function () {

              const templateName = botMessage?.templateApplied?.[0]?.templateName || "default";
              const isDefaultTemplate = templateName == "default";

              const renderFields = [];
              const settings = botMessage?.settings || {};
              const supported = settings?.supported ?? false;

              const schema = settings?.schema ?? {};
              const form = settings?.form ?? {};

              const type = schema?.type ?? "TEXT";
              const label = schema?.label ?? l("Escribe un mensaje%PA004");
              const placeholder = isDefaultTemplate ? l("¿En qué te puedo ayudar?%PA005") : (schema?.placeholder ?? l("Ingresa un valor%GA092"));
              const multipleFiles = schema?.multiple_files ?? false;
              const options = schema?.options ?? [];
              const openText = schema?.open_text ?? false;
              const assetType = schema?.asset_type ?? "file";
              const assetValue = schema?.asset_value;

              if (type == "TEXT" || type == "TEXT_AREA" || isLoading)
                renderFields.push(
                  <DynamicTextArea
                    id="chat-prompt-text" className="position-relative"
                    value={values["message"]}
                    onChange={(value) => setFieldValue("message", value)}
                    minRows={type == "TEXT_AREA" ? 2 : 1}
                    maxRows={type == "TEXT_AREA" ? 8 : 5}
                    placeholder={placeholder} />);
              else if (type == "SELECT") {
                if (openText)
                  renderFields.push(
                    <Field id="chat-prompt-select" name="message" type="text" autocomplete="off" placeholder={placeholder} />);
                renderFields.push(
                  <div className={`input-options overflow-auto ${openText ? "" : "fixed-select"}
                    animate__animated animate__fadeIn animate__faster`}>
                    {options.map((option, index) => (
                      <label
                        key={index}
                        onClick={() => {
                          onSendMessage({ message: option.label }, { setFieldValue, });
                        }}
                        className="message suggestion text-truncate">
                        {option.label}
                      </label>
                    ))}
                  </div>
                );
              }
              else if (type == "DATE")
                renderFields.push(<Field id="chat-prompt-date" name="message" type="date" />)
              else if (type == "DATE_TIME")
                renderFields.push(<Field id="chat-prompt-date-local" name="message" type="datetime-local"

                />)
              else if (type == "FILE")
                renderFields.push(
                  <div id="chat-prompt-attachments">
                    <FileField name="attachments" label={label} setFieldValue={setFieldValue} multiple={multipleFiles}
                      setLoading={(loading) => setFieldValue("attachments_loading", loading)}
                    />
                  </div>)
              else if (type == "ASSET") {
                if (assetType == "image") renderFields.push(<img src={assetValue} alt={label} />)
                else if (assetType == "file") renderFields.push(
                  <a href={assetValue} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary">
                    <i className="fas fa-file-alt mr-2"></i>{l("Ver archivo%PA006")}
                  </a>
                )
              }
              else if (type == "EXCEL")
                renderFields.push(<ExcelField
                  defaultSelectedSheet={schema?.excel_sheet}
                  defaultOffset={schema?.excel_offset}
                  referenceColumns={schema?.excel_structure}
                  ignoreColumns={true}
                  isSingleImport={true}
                  showAdvancedOptions={false}
                  showPreview={false}
                  onLoadFile={(data) => {
                    const { file, sheet, offset, rawRows, error } = data;
                    setFieldValue("message", { file, sheet, offset, rows: rawRows, columns: schema?.excel_structure, error })
                  }}
                  setLoading={(loading) => setFieldValue("attachments_loading", loading)}
                />);
              else if (!supported) {

                let isSchemaBuilder = schema?.type == "SCHEMA_BUILDER" || schema?.type == "COLLECTION_BUILDER";
                let initialValues = isSchemaBuilder ? { [schema.name]: schema.initial_schema } : {};
                let initialSchema = [{ ...schema, label: null, placeholder: null, show_if: [] }];

                renderFields.push(<div className="custom-input overflow-auto">
                  <SchemaForm
                    parentRef={subFormRef}
                    initialValues={initialValues}
                    onSubmit={(values) => {
                      onSendMessage({ message: values }, { setFieldValue });
                    }}
                    schema={initialSchema}
                    appId={form?.app_id}
                    actionId={form?.action_id}
                    flowId={form?.flow_id}
                    nodeId={form?.node_id}
                    executionId={form?.execution_id}
                    isReadOnly={false}
                    showSideSteps={false}
                    submitComponent={() => {

                      if (initialSchema.length == 1 && initialSchema[0].type == "BUTTON" && initialSchema[0].button_type == "link")
                        return <></>;

                      return <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                          subFormRef.current.submitForm();
                        }}
                      >
                        {l("Continuar%GA007")}
                      </button>;

                    }}
                  />
                </div>)
              }

              return <>

                {
                  !isExecutionChat && type == "TEXT" && !isPreview &&
                    <div
                       className="wizard-btn position-absolute mt-1
                      animate__animated animate__fadeIn animate__faster">
                      <Wizard
                        flow={flow}
                        mainProcessName="CREATE_INPUT_PROMPT"
                        params={{
                          chat_id: chat?.id,
                        }}
                        onCompleted={(data) => {
                          
                          if(!data || !data.lastStep) return;

                          const snapshotResult = data?.lastStep?.result?.output || {};
                          const nodeOutput = data?.lastStep?.flowNode?.outputValues || [];
                          const promptOutput = nodeOutput?.find(k => k.name == "suggestion_identified") || {};
                          const promptKey = promptOutput?.value?.replace("#", "");
                          const message = snapshotResult?.[promptKey] || "";
                          
                          if (message) {
                            setFieldValue("message", message);
                            setFieldValue("is_wizard_suggestion", true);
                          }

                        }}
                      />
                    </div>
                }

                <div className="animate__animated animate__fadeIn animate__faster">{renderFields}</div>

                <div className="input-actions">

                  {isCancelable &&
                    <button type="button" className="fas fa-stop cancel"
                      onClick={() => onClickCancelChatAction()}>
                    </button>}

                  {/* Temp hide 250918 
                  ``isDeveloper && type == "TEXT" &&
                    <button type="button" className="fas fa-paperclip attach"
                      onClick={() => onClickAttachFiles(setFieldValue)}>
                      {
                        values.attachments && values.attachments.length > 0 &&
                        <span className="attach-count">{values.attachments.length}</span>
                      }
                    </button>
                    */}

                  <button type={isPreview ? "button" : "submit"}
                    className={"send fas " +
                      (values["attachments_loading"] == true ? "fa-spinner " : "fa-circle-arrow-right ")}
                    disabled={isLoading || (!values["message"] &&
                      (!values["attachments"] || values["attachments"]?.length == 0 || values["attachments_loading"] == true))} />

                </div>

              </>

            }()
          }

        </Form>}
    </Formik>
  </div>
}

export default ChatInput;